export default __webpack_public_path__ + "static/media/complokHeaderLogo.0d610d8d.png";